// extracted by mini-css-extract-plugin
export default {"fullWidth":"In-z","image":"Jn-z","lazyLoadPicture":"Kn-z","lazyLoadSpinner":"Ln-z","lazyLoadSpin":"Mn-z","lazyLoadImage":"Nn-z","hasStyledAspectRatio":"On-z"};